import axios from 'axios'

$(document).ready(function () {
  $('.quantity-selector-up').on('click', function () {
    const input = $(this).prev()
    const current = Number(input.val())
    const selector = $(this).parent()

    if (selector.hasClass('cart-quantity')) {
      const id = Number(selector.attr('data-id'))

      axios.post('/cart/add', { id }).then((res) => {
        location.reload()
      })
    } else {
      input.val(current + 1)
    }
  })

  $('.quantity-selector-down').on('click', function () {
    const input = $(this).next()
    const current = Number(input.val())
    const selector = $(this).parent()

    if (current > 1) {
      if (selector.hasClass('cart-quantity')) {
        const id = selector.attr('data-id')

        axios.post('/cart/change.js', { id, quantity: current - 1 }).then((res) => {
          location.reload()
        })
      } else {
        input.val(current - 1)
      }
    }
  })
})
